module.exports = __webpack_public_path__ + "img/cube2.5df664b3.png";